import React from 'react'
import { Container, Card } from 'react-bootstrap'
import coder from '../../Assets/cover.png'
import './About.css'
import { NavBar } from '../../Components/Navigation/NavBar'
import { Footer } from '../../Components/Footer/Footer'
export const About = () => (
  <div style={{ backgroundColor: 'white' }}>
    <NavBar />
    <h2 className="text-center text-white mt-3 mb-2">
      "Effort may fail. But don't fail to make an effort" !{' '}
    </h2>
    <Container>
      <Card className="card-m mt-3" style={{ width: '100', margin: '9px' }}>
        <Card.Img
          className="img-fluid codeImg"
          variant="top"
          src={coder}
          alt={coder}
        />
        <Card.Body style={{ backgroundColor: 'rgb(184, 246, 233)' }}>
          <Card.Title>Shreyas Bansode @bansodeshreyas</Card.Title>
          <Card.Title>Role: Software Developer & Tech lead</Card.Title>
        </Card.Body>
      </Card>
      <Card className="card-m mt-3" style={{ width: '100', margin: '9px' }}>
        <Card.Img
          className="img-fluid codeImg"
          variant="top"
          src={coder}
          alt={coder}
        />
        <Card.Body style={{ backgroundColor: 'rgb(184, 246, 233)' }}>
          <Card.Title>Varandeep Bhalla @varandeep</Card.Title>
          <Card.Title>Role: Software Developer</Card.Title>
        </Card.Body>
      </Card>
      <Card className="card-m mt-3" style={{ width: '100', margin: '9px' }}>
        <Card.Img
          className="img-fluid codeImg"
          variant="top"
          src={coder}
          alt={coder}
        />
        <Card.Body style={{ backgroundColor: 'rgb(184, 246, 233)' }}>
          <Card.Title>Sachin Sharma @Maverick-01</Card.Title>
          <Card.Title>Role: Software Developer</Card.Title>
        </Card.Body>
      </Card>
      <Card className="card-m mt-3" style={{ width: '100', margin: '9px' }}>
        <Card.Img
          className="img-fluid codeImg"
          variant="top"
          src={coder}
          alt={coder}
        />
        <Card.Body style={{ backgroundColor: 'rgb(184, 246, 233)' }}>
          <Card.Title>Prajwal Ladkat @prajwal080501</Card.Title>
          <Card.Title>Role: UI/UX Desgining & Frontend Developer </Card.Title>
        </Card.Body>
      </Card>
      <Card
        className="card-m mt-3 mb-3"
        style={{ width: '100', margin: '9px' }}
      >
        <Card.Img
          className="img-fluid codeImg"
          variant="top"
          src={coder}
          alt={coder}
        />
        <Card.Body style={{ backgroundColor: 'rgb(184, 246, 233)' }}>
          <Card.Title>Manas Darpelli @HalfBrain07</Card.Title>
          <Card.Title>Role: Frontend Developer</Card.Title>
        </Card.Body>
      </Card>

      <Card className="card-m mt-3" style={{ width: '100', margin: '9px' }}>
        <Card.Img
          className="img-fluid codeImg"
          variant="top"
          src={coder}
          alt={coder}
        />
        <Card.Body style={{ backgroundColor: 'rgb(184, 246, 233)' }}>
          <Card.Title>Siddharth Bansode</Card.Title>
          <Card.Title>Role: Professional Video editor</Card.Title>
        </Card.Body>
      </Card>
    </Container>
    <Footer/>
  </div>
)
